/* Riot v7.1.0, @license MIT */
/**
 * no-op function needed to add the proper types to your component via typescript
 * @param {Function|Object} component - component default export
 * @returns {Function|Object} returns exactly what it has received
 */
/* istanbul ignore next */
const withTypes = component => component;

export { withTypes };
